import React from 'react'
import styled, { keyframes } from 'styled-components'

const dash = keyframes`
  0% {
    stroke-dashoffset: 1000;
  }
  100% {
    stroke-dashoffset: 0;
  }
`

const fadeIn = keyframes`
  0%{
    opacity: 0;
    transform: scale(0.3);
  }
  100%{
    opacity: 1;
    transform: scale(1);
  }
`

const StyledSvg = styled.svg`
  width: ${({ size }) => size || 50}px;
  margin: 0;

  circle.outer {
    stroke-dasharray: 1000;
    stroke-dashoffset: 0;
    animation: ${dash} .9s ease-in-out;
  }

  line {
    stroke-dasharray: 1000;
    stroke-dashoffset: 1000;
    animation: ${dash} .9s .35s ease-in-out forwards;
  }

  circle.dot {
    stroke-dasharray: 1000;
    stroke-dashoffset: 0;
    animation: ${fadeIn} .9s .45s ease-in-out forwards;
  }
`

const AnimatedXCircle = ({ size }) => {
  return (
    <StyledSvg size={size} version='1.1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 130.2 130.2'>
      <circle className='outer' fill='none' stroke='#F8BB86' stroke-width='6' stroke-miterlimit='10' cx='65.1' cy='65.1' r='62.1' />
      <line fill='none' stroke='#F8BB86' stroke-width='8' stroke-linecap='round' stroke-miterlimit='10' x1='50%' y1='20%' x2='50%' y2='60%' />
      <line className='dot' fill='none' stroke='#F8BB86' stroke-width='8' stroke-linecap='round' stroke-miterlimit='10' x1='50%' y1='75%' x2='50%' y2='78%' />
    </StyledSvg>
  )
}

export default AnimatedXCircle



// WEBPACK FOOTER //
// ./src/Components/AnimatedWarning/AnimatedWarning.jsx